import Yup from 'yup';
import validationMessages from 'components/signup_modal/signup_modal_validation_message';
import { NO_ERROR_MESSAGE } from 'components/touched_field_error';

// Reference: https://github.com/jquense/yup/issues/298#issuecomment-559017330
const emptyStringToNull = (value, originalValue) =>
  originalValue.toString().trim() === '' ? null : value;

const jQueryMaskRegexOrEmptyString = /(\([0-9]{3}\) [0-9]{3}-[0-9]{4})|^$/;
const {
  companyMessage,
  emailMessage,
  nameMessage,
  numberEmployeesMessage,
  phoneMessage,
  uniqueEmailMessage,
} = validationMessages;

const emailSchema = Yup.string()
  .email(emailMessage)
  .required(emailMessage);

export const uniqueEmailSchema = api =>
  Yup.string().test('unique-email', uniqueEmailMessage, async email => {
    const validEmail = await emailSchema.isValid(email);
    if (validEmail) {
      return api('/invite/existing-user-email-lookup', { email })
        .then(isTaken => !isTaken)
        .catch(() => true);
    }
    return true;
  });

export default (fromGoogleSso, googleSsoEmail) =>
  Yup.object().shape({
    company_lead: Yup.object().shape({
      company_name: Yup.string()
        .min(2, companyMessage)
        .required(companyMessage),
      email: Yup.string()
        .email(emailMessage)
        .required(emailMessage),
      full_name: Yup.string()
        .matches(/^[A-zÀ-ú]+ [A-zÀ-ú]+/, nameMessage)
        .required(nameMessage),
      number_employees: Yup.number()
        .min(0, numberEmployeesMessage)
        .max(99999, numberEmployeesMessage)
        .transform(emptyStringToNull)
        .nullable(),
      phone: Yup.string().matches(jQueryMaskRegexOrEmptyString, phoneMessage),
    }),

    user: Yup.object().when('company_lead.email', {
      is: val => !(fromGoogleSso && val === googleSsoEmail),
      then: Yup.object().shape({
        password: Yup.string()
          .trim()
          .min(8, `Please choose a password with 8 or more characters.`)
          .matches(
            /^(?=.*[a-zA-Z])(?=.*[0-9]).*$/,
            'Please choose a password with at least one letter and one number.'
          )
          .required('Password is required'),

        password_confirmation: Yup.string()
          .trim()
          .oneOf([Yup.ref('password')], 'Passwords do not match.')
          .required(NO_ERROR_MESSAGE),
      }),
      otherwise: Yup.object().nullable(true),
    }),
  });
